class LandingPageApp {
  constructor() {
    this.decadeSections = [...document.querySelectorAll(".decade-wrapper")];
    this.nav = document.querySelector("store-header.header");
    this._init();
  }

  _init() {
    this._createLenis();
    this._renderLenis();
    gsap.registerPlugin(ScrollTrigger, Flip);
    this._createHero();
    this._animateFiveDecades();
    this._resetYearLinkBehavior();

    if (this.decadeSections.length) {
      this.decadeSections.forEach((section, i) => {
        this._createDecade(section, i);
      });
    }

    this._createFeature();

    setTimeout(() => {
      ScrollTrigger.refresh();
      console.log("ScrollTrigger refreshed");
    }, 2500);

    console.log("Animations have been initialized");
  }

  _createLenis() {
    this.lenis = new Lenis({
      lerp: 0.05,
      easing: (t) => 1 - Math.pow(1 - t, 5),
    });
  }

  _renderLenis(time) {
    this.lenis.raf(time);
    requestAnimationFrame(this._renderLenis.bind(this));
  }

  _getElements(section) {
    if (section === "hero") {
      return {
        mainWrap: document.querySelector(".editorial_hero__video"),
        flipWrap: document.getElementById("hero_video_flip_container"),
        contentWrap: document.querySelector(".editorial_hero__content"),
        content: document.querySelector(".hero_content"),
        fiveDecadeContent: document.querySelector(
          ".editorial_hero__decade_wrapper"
        ),
        years: document.querySelector(".hero_years"),
        video: document.getElementById("hero_video_flip_element"),
      };
    } else {
      return {
        horScroll: section.querySelector(".hor-scroll"),
        horScrollWrap: section.querySelector(".hor-scroll-wrapper"),
        title: section.querySelector(".title-wrapper"),
        content: section.querySelector(".content-wrapper"),
      };
    }
  }

  _setInitState(section) {
    const { horScroll, title, content } = this._getElements(section);
    gsap.set(horScroll, { x: window.innerWidth });
    gsap.set(title, { yPercent: -150, y: 0, autoAlpha: 0, force3D: false });
    gsap.set(content, { autoAlpha: 0, xPercent: 20, x: 0, force3D: false });
    gsap.set(section, { opacity: 1 });
  }

  _resetYearLinkBehavior() {
    const { years: yearsWrap } = this._getElements("hero");
    const years = [...yearsWrap.querySelectorAll(".year")];

    years.forEach((link) => {
      link.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href");
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          history.pushState(null, null, targetId);
          target.scrollIntoView({ behavior: "auto" });
        }
      });
    });
  }

  _animateFiveDecades() {
    const navHeight = this.nav.offsetHeight;
    const heroDecadeSection = document.querySelector(
      ".editorial_hero__decades"
    );
    const downArrow = document.querySelector(".scroll_down .icon-custom.arrow");
    const decadeNav = this.nav.querySelector(".decade__nav.mobile");

    const { fiveDecadeContent } = this._getElements("hero");
    const fiveDecadeElements = fiveDecadeContent.children;

    gsap.set(fiveDecadeElements, {
      autoAlpha: 0,
      xPercent: -10,
      x: 0,
      force3D: false,
    });

    gsap.to(fiveDecadeElements, {
      xPercent: 0,
      x: 0,
      autoAlpha: 1,
      force3D: false,
      stagger: { each: 0.05, from: "end" },
      scrollTrigger: {
        trigger: heroDecadeSection,
        start: `top top+=${navHeight}`,
        toggleActions: "play none none reverse",
        onEnter: () => {
          decadeNav?.classList.remove("inactive");
        },
        onLeaveBack: () => {
          decadeNav?.classList.add("inactive");
        },
      },
    });

    gsap.to(downArrow, {
      fill: "white",
      scrollTrigger: {
        trigger: heroDecadeSection,
        start: "top bottom",
        end: "bottom 40%",
        toggleActions: "play reset play reset",
      },
    });
  }

  _createHero() {
    const elements = this._getElements("hero");
    const navHeight = this.nav.offsetHeight;

    const missingElements = Object.entries(elements).filter(([key, el]) => !el);
    if (missingElements.length) {
      console.log(
        "Missing elements:",
        missingElements.map(([key]) => key)
      );
      return;
    }

    const { mainWrap, flipWrap, contentWrap, content, video } = elements;

    let flipCtx;
    flipCtx && flipCtx.revert();

    flipCtx = gsap.context(() => {
      const contentElements = content.children;

      gsap.set(video, { force3D: true });
      gsap.set(contentElements, {
        autoAlpha: 0,
        xPercent: -10,
        x: 0,
        force3D: false,
      });

      const endState = Flip.getState(flipWrap);
      const tweenMeetPoint = `clamp(top+=${navHeight} top+=${navHeight})`;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: mainWrap,
          start: "clamp(top 50%)",
          endTrigger: contentWrap,
          end: tweenMeetPoint,
          invalidateOnRefresh: true,
          scrub: true,
        },
      });

      tl.add(
        Flip.fit(video, endState, {
          ease: "none",
          duration: 1,
          force3D: true,
          onComplete: () => {
            const staticVideo = document.getElementById(
              "hero_video_static_element"
            );
            const decadeNav = this.nav.querySelector(".decade__nav.mobile");

            video.classList.add("hidden");
            staticVideo.classList.remove("hidden");

            gsap.to([contentElements], {
              xPercent: 0,
              x: 0,
              autoAlpha: 1,
              force3D: false,
              stagger: { each: 0.05, from: "end" },
              scrollTrigger: {
                trigger: contentWrap,
                start: tweenMeetPoint,
                invalidateOnRefresh: true,
                toggleActions: "play none none reverse",
                onLeaveBack: () => {
                  video.classList.remove("hidden");
                  staticVideo.classList.add("hidden");
                  decadeNav?.classList.add("inactive");
                },
              },
            });
          },
        })
      );
    });
  }

  _createFeature() {
    const featureSection = document.querySelector(
      ".section--editorial-feature"
    );
    if (!featureSection) return;

    const featureBox = featureSection.querySelector(".feature_video_box");
    const featureContent = featureSection.querySelector(".feature_content");
    const featureLoop = featureSection.querySelector(".feature_video_loop");

    if (!featureBox || !featureContent || !featureLoop) return;

    const navHeight = this.nav?.offsetHeight || 0;

    gsap.set(featureBox, { x: -300, autoAlpha: 0, force3D: false });

    const featureTitle = featureContent.querySelector(".feature_title");
    const featureBody = featureContent.querySelector(".feature_description");
    const featureLink = featureContent.querySelector(".feature_link");

    if (featureTitle)
      gsap.set(featureTitle, { autoAlpha: 0, x: -60, force3D: false });
    if (featureBody)
      gsap.set(featureBody, { autoAlpha: 0, x: -40, force3D: false });
    if (featureLink)
      gsap.set(featureLink, { autoAlpha: 0, x: -40, force3D: false });

    const featureTl = gsap.timeline({
      scrollTrigger: {
        trigger: featureSection,
        start: `top top+=${navHeight}`,
        end: `+=${window.innerHeight * 1.5}`,
        scrub: 0.5,
        pin: true,
        pinSpacing: true,
        invalidateOnRefresh: true,
      },
      defaults: { duration: 1, ease: "power2.out" },
    });

    featureTl
      .to(
        featureBox,
        {
          x: 0,
          autoAlpha: 1,
          force3D: false,
          onComplete: () => {
            featureLoop.classList.add("is-animated");
          },
        },
        0
      )
      .to(featureTitle, { x: 0, autoAlpha: 1, force3D: false }, 0.3)
      .to(featureBody, { x: 0, autoAlpha: 1, force3D: false }, 0.5)
      .to(featureLink, { x: 0, autoAlpha: 1, force3D: false }, 0.5);

    setTimeout(() => {
      const st = featureTl.scrollTrigger;
      if (st && st.pin) {
        const pinSpacer = st.pin.parentNode;
        if (pinSpacer && pinSpacer.classList.contains("pin-spacer")) {
          pinSpacer.style.maxWidth = "none";
          pinSpacer.style.width = "100%";
        }
        st.pin.style.maxWidth = "none";
        st.pin.style.width = "100%";
      }
    }, 100);
  }

  _createDecade(section, i) {
    this._setInitState(section);
    this._animateDecadeContent(section, i);
  }

  _animateDecadeContent(section, i) {
    const { horScroll, title, content } = this._getElements(section);
    const navHeight = this.nav.offsetHeight;
    const delay = i === 0 ? 3000 : 2000;

    setTimeout(() => {
      this._startAnimation(horScroll, title, content, navHeight, section, i);
    }, delay);
  }

  _startAnimation(horScroll, title, content, navHeight, section, i) {
    const padding = 0; // 最後の画像の右側に残したい余白
    const scrollWidth = -(horScroll.offsetWidth - window.innerWidth + padding);
    const duration = -(scrollWidth / 100);
    const isLastSection = this.decadeSections.length - 1 === i;
    const scrollDownArrow = document.querySelector(
      ".scroll_arrow__wrapper.scroll_down"
    );

    const mainTl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: `top top+=${navHeight}`,
        end: `top+=${section.offsetHeight + 2000}px`,
        scrub: 0.5,
        pin: true,
        invalidateOnRefresh: true,
        onEnterBack: () => {
          if (isLastSection) scrollDownArrow.classList.remove("hidden");
        },
        onLeave: () => {
          if (isLastSection) scrollDownArrow.classList.add("hidden");
        },
      },
      defaults: { duration: 2, ease: "power4.out" },
    });

    mainTl
      .to(title, { autoAlpha: 1 })
      .to(title, { yPercent: 0, y: 0, force3D: false })
      .to(content, { xPercent: 0, x: 0, autoAlpha: 1, force3D: false }, "<50%")
      .to(
        horScroll,
        { x: scrollWidth, ease: "none", duration: duration },
        "<0%"
      );

    // pin spacerのmax-widthをリセット
    setTimeout(() => {
      const st = mainTl.scrollTrigger;
      if (st && st.pin) {
        const pinSpacer = st.pin.parentNode;
        if (pinSpacer && pinSpacer.classList.contains("pin-spacer")) {
          pinSpacer.style.maxWidth = "none";
          pinSpacer.style.width = "100%";
        }
        st.pin.style.maxWidth = "none";
        st.pin.style.width = "100%";
      }
    }, 100);
  }
}

// ----- FIND NAV BAR HEIGHT
const navHeightHandler = {
  elements: {
    nav: document.querySelector("store-header.header"),
    announcement_bar: document.querySelector(
      "announcement-bar.announcement-bar"
    ),
    pre_footer: document.querySelector("section.pre-footer"),
  },
  body: document.querySelector("body"),
  setVariableStr() {
    let variableStr = "";
    for (const [key, value] of Object.entries(this.elements)) {
      const height = value?.offsetHeight || 0;
      const handleizedKey = key.split("_").join("-");
      variableStr += `--${handleizedKey}-height: ${height}px; `;
    }
    return variableStr;
  },
  init() {
    this.body.style.cssText = this.body.style.cssText + this.setVariableStr();
  },
};

// ----- OPEN EXTERNAL LINKS IN NEW TAB
const externalLinkHandler = {
  links: [...document.querySelectorAll("a:not(.cookie-policy)")],
  init() {
    this.links.forEach((link) => {
      if (link.host !== window.location.hostname) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noreferrer noopener");
      }
    });
  },
};

function initScripts() {
  navHeightHandler.init();
  externalLinkHandler.init();
  new LandingPageApp();
}

document.addEventListener("DOMContentLoaded", () => {
  initScripts();
});
